<template>
    <content-loading row v-if="!modelLoaded" :loadingMessage="modelLoadingMessage" ></content-loading>
    <div v-else>
        <v-alert :value="requestFailed" type="error" outline class="mt-4">
            <span>{{requestErrorMessage}}</span>
        </v-alert>
        <v-card max-width="400" flat>
            <v-card-title primary-title>
                <div>
                    <div class="headline">{{companyUser.name}}</div>
                    <div>{{companyUser.email}}</div>
                    <div>Role: {{companyUser.role}}</div>
                </div>
            </v-card-title>
            <v-card-text>
                <loading v-if="submitting" loadingMessage="Removing team member..."></loading>
                <template v-else>
                    <v-btn class="error" @click="submit({})" block>Remove User From Team</v-btn>
                </template>
            </v-card-text>
            <v-card-actions>
                <v-btn flat @click="$router.go(-1)">Back</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
  import {LoadModelMixin} from '@/views/app/mixins'

  export default {
    name: 'CompanyTeamUser',
    mixins: [LoadModelMixin],
    props: {
      firebaseUser: {
        required: true
      },
      user: {
        required: true
      },
      systemConfig: {
        type: Object,
        required: true
      },
      company: {
        type: Object,
        required: true
      },
      uid: {
        // This is the company uid
        type: String,
        required: true
      },
      team_uid: {
        type: String,
        required: true
      }
    },
    data: () => ({
      formDirty: false,
      warnDialog: false,
      submitting: false,
      requestFailed: false,
      requestErrorMessage: '',
      requestErrorDetailedMessage: '',
      initialValue: null
    }),
    computed: {
      companyUser () {
        // Simply an alias of model
        return this.model
      },
      modelUID () {
        return this.team_uid
      },
      companyUID () {
        // Simply an alias of uid route prop
        return this.uid
      },
      apiPath () {
        return `/admin/company/${this.uid}/team/${this.team_uid}`
      }
    },
    methods: {
      getModelRef(uid) {
        return this.$firebaseClient.getCompanyUserRef(this.companyUID, uid)
      },
      submit () {
        const self = this
        self.submitting = true
        self.requestFailed = false
        self.requestErrorMessage = ''
        self.requestErrorDetailedMessage = ''
        // Commit the payload and handle exceptions
        self.$firebaseClient.callApi(self.apiPath, null, 'DELETE')
          .then((response) => {
            self.handleSuccess(response)
          })
          .catch((error) => {
            self.handleError(error)
          })
      },
      handleError(error) {
        // This is the default error handler for api requests. You can override this as you see fit.
        const self = this
        self.requestFailed = true
        self.requestErrorMessage = 'There was a problem with the your request. If you continue to have problems please contact support.'
        // Error.returnedData will contain any messages sent back from the server
        // We need to format this data into a user readable form
        if (error.returnedData) {
          self.requestErrorDetailedMessage = error.returnedData
        }

        self.submitting = false
        console.log(`[${self.formName}]: Failed to submit`)
      },
      handleSuccess(response) {
        const self = this
        self.submitting = false
        self.$notifications.$emit('toast', {text: 'Successfully saved your changes!', colour: 'success', buttonColour: ''})
        console.log(`[${self.formName}]: Successfully submitted: ${response}`)
        self.$router.push({name: 'admin.company.team', params: {uid: this.uid}})
      }
    }
  }
</script>

<style scoped>

</style>
